import { FULL_DOCUMENTS, GLOBAL_CATALOGS } from '../types';

const initialState = {
  isLoading: false,
  menus: [],
  value: '',
  result: {
    list: [],
    total: 0,
    page: 1,
    rowsPerPage: 10,
    pages: 10,
  },

  // 
  order: {
    list: [],
    total: 0,
    page: 1,
    rowsPerPage: 10,
    pages: 10,
  },
  material: {
    list: [],
    total: 0,
    page: 1,
    rowsPerPage: 10,
    pages: 10,
  },

  // 
  details: {},
};

const documentsReducer = function (state = initialState, action) {
  switch (action.type) {
    case FULL_DOCUMENTS.Loading: {
      return {
        ...state,
        isLoading: action.payload
      };
    }
    case FULL_DOCUMENTS.Value: {
      return {
        ...state,
        value: action.payload
      };
    }
    case FULL_DOCUMENTS.List: {
      return {
        ...state,
        result: { ...action.payload }
      };
    }
    case GLOBAL_CATALOGS.Documents.Root: {
      return {
        ...state,
        menus: action.payload
      };
    }
    case GLOBAL_CATALOGS.Documents.AffairsForm.List: {
      return {
        ...state,
        order: { ...action.payload }
      };
    }
    case GLOBAL_CATALOGS.Documents.MaterialDownload.List: {
      return {
        ...state,
        material: { ...action.payload }
      };
    }
    default: {
      return state;
    }
  }
};

export default documentsReducer;
